// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { observable, action } from "mobx";
import { MyNotificationsApi } from "../api/my-notifications.api";
import { NotificationsApi } from "../api/notifications.api";

export default class NotificationsStore {
  @observable notifications: Array<any> = [];
  @observable notices: Array<any> = [];
  @observable notice: any;
  @observable notification: any;
  @observable alerts: Array<any> = [];

  @action getMyNotifications = async (query?: any) => {
    this.notifications = await MyNotificationsApi.getPaginatedNotifications(
      query ? query : ""
    );
  };

  @action getNotification = async (id: number) => {
    this.notification = await MyNotificationsApi.getNotification(id);
    return this.notification;
  };

  @action getAvisos = async () => {
    this.notices = await NotificationsApi.getAvisos();
  };

  @action getAviso = async (id: number) => {
    this.notice = await NotificationsApi.getAviso(id);
  };

  @action getAvisoSICTMWS = async (id: number) => {
    this.notice = await NotificationsApi.getAvisoSICTMWS(id);
    return this.notice;
  };

  @action getAlerts = async () => {
    this.alerts = await NotificationsApi.getAlerts();
  };
}
